
















import {Vue, Component} from 'vue-property-decorator'
import {InputSelect} from '@simpli/vue-input'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import OrbitCountdown from '@/components/orbit/OrbitCountdown.vue'

@Component({
  components: {
    InputSelect,
    OrbitCountdown,
  },
})
export default class FilterCurrentRoundOrbit extends Vue {
  roundEndTimestampMs: number | null = null

  mounted() {
    this.fetchRoundEndTime()
  }

  async fetchRoundEndTime() {
    try {
      const roundEndTime = await OrbitHelper.getRoundEndTimeMs()
      const endTimestamp = Number(roundEndTime)

      if (isNaN(endTimestamp) || endTimestamp <= 0) {
        this.roundEndTimestampMs = null
        return
      }

      const endMs = endTimestamp < 1e12 ? endTimestamp * 1000 : endTimestamp
      if (endMs <= Date.now()) {
        this.roundEndTimestampMs = null
        return
      }

      this.roundEndTimestampMs = endMs
    } catch (error) {
      console.error('Error fetching round end time:', error)
      this.roundEndTimestampMs = null
    }
  }
}
